module.exports = __webpack_public_path__ + "static/media/5.Earth Auger (Hole Drigger).ad042caf.jpg";